<template>
  <row>
    <column>
      <label :for="filterElement.idForProp('filter')">
        {{filterElement.label_title}}
      </label>
      <br>
      <input
        v-model="isOn"
        :id="filterElement.idForProp('filter')"
        type="checkbox"
        class="toggle-btn">
    </column>
  </row>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewFilterMixin from "../../../common/mixins/listViews/listViewFilterMixin";

  export default Vue.extend({
    mixins: [
      listViewFilterMixin,
    ],
    data: function () {
      return {
        isOn: null
      };
    },
    methods: {
      setDefaultFilter(): void {
        if (this.isFilterInQuery || this.isInDashBoardDrillDown) {
          this.isOn = this.queryValue === 'true'
        } else {
          this.isOn = this.filterElement.default_value
        }
      },
      reset(): void {
        this.isOn = false;
      },
    },
    watch: {
      isOn: function (newVal, oldVal) {
        this.addFilterToQuery(newVal)
      },
    },
  });
</script>